/**
 * SteemWorld Followers API
 *
 * Provides methods for fetching follower data from the SteemWorld followers_api.
 */

import { followersApi } from '../client'
import type { FollowCountersResponse, FollowCountersResult } from '../types'

/**
 * Fetches follower and following counts for a user
 *
 * @param username - The account username
 * @returns Follower and following counts
 */
export async function getCounters(username: string): Promise<FollowCountersResult> {
  try {
    const response = await followersApi.request<FollowCountersResponse>(
      `/getCounters/${username}`
    )

    return {
      followers: response.result?.followers ?? 0,
      following: response.result?.following ?? 0,
    }
  } catch {
    // Return default values on error (graceful degradation)
    return { followers: 0, following: 0 }
  }
}

/**
 * Followers API namespace
 */
export const followers = {
  getCounters,
}
